module.exports = __webpack_public_path__ + "static/media/palm-marin.747bdd93.jpg";